import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const messageIconDark = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18V6Z" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3 6L12 13L21 6" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
);
